import { AppConfig } from '../config'

const DOMAIN = AppConfig.getBaseURL()
const EMAIL_DOMAIN = AppConfig.getEmailBaseUrl()
const EMAIL_API_KEY = AppConfig.getEmailApiKey()
const V1_ADMIN_PATH = '/v1/admin/private/api'
const URLS = {
  BASE_URL: DOMAIN,
  EMAIL_BASE_URL: EMAIL_DOMAIN,
  LOGIN: `${V1_ADMIN_PATH}/login`,
  GET_CLIENT_INFO: `${V1_ADMIN_PATH}/get-client-info`,
  UPDATE_CLIENT_INFO: `${V1_ADMIN_PATH}/update-client-info`,
  UPDATE_PAYTM_CR_SETTINGS: `${V1_ADMIN_PATH}/update/paytm/cr/settings`,
  UPDATE_PRINTER_SETTINGS: `${V1_ADMIN_PATH}/update-printer-settings`,
  GET_PRODUCTS_LIST: `${V1_ADMIN_PATH}/get-product-list`,
  DELETE_PORODUCT: `${V1_ADMIN_PATH}/delete-product`,
  CREATE_PRODUCT: `${V1_ADMIN_PATH}/create-product`,
  UPADTE_PRODUCT: `${V1_ADMIN_PATH}/update-product`,
  ADD_CATEGORY: `${V1_ADMIN_PATH}/create-category`, //
  GET_CATEGORY: `${V1_ADMIN_PATH}/get-category-list`,
  DELETE_CATEGORY: (id: string) => `${V1_ADMIN_PATH}/delete-category/${id}`, //
  UPDATE_CATEGORY: (id: string) => `${V1_ADMIN_PATH}/update-category/${id}`,
  FILE_UPLOAD_URL: `${V1_ADMIN_PATH}/uploadFile`,
  CREATE_BILL: `${V1_ADMIN_PATH}/create-bill`,
  MODIFY_BILL: `${V1_ADMIN_PATH}/bills/modify/bill`,
  DELETE_BILL: `${V1_ADMIN_PATH}/bills/delete/bill`,
  GET_BILLS: (startDate: number, endDate: number) =>
    `${V1_ADMIN_PATH}/get-bills?startTime=${startDate}&endTime=${endDate}`,
  UPDATE_TAKEAWAY_BILL_STATUS: (id: string, status: string) =>
    `${V1_ADMIN_PATH}/bills/update/takeaway/status/${id}?status=${status}`,
  UPDATE_BILL_PAYMENT_MODE: (billId: string, paymentMethod: string) =>
    `${V1_ADMIN_PATH}/bills/update/payment/${billId}?paymentMethod=${paymentMethod}`,
  DOWNLOAD_BILL: (clientId: string, startDate: string, endDate: string) => `${V1_ADMIN_PATH}/download/${clientId}/report?startTime=${startDate}&endTime=${endDate}`,
  GET_FLOORS: `${V1_ADMIN_PATH}/floors`,
  ADD_FLOOR: `${V1_ADMIN_PATH}/floors`,
  UPDATE_FLOOR: (id: string) => `${V1_ADMIN_PATH}/floors/${id}`,
  DELETE_FLOOR: (id: string) => `${V1_ADMIN_PATH}/floors/${id}`,
  GET_PLACES: `${V1_ADMIN_PATH}/places`,
  ADD_PLACE: `${V1_ADMIN_PATH}/places`,
  UPDATE_PLACE: (id: string) => `${V1_ADMIN_PATH}/places/${id}`,
  DELETE_PLACE: (id: string) => `${V1_ADMIN_PATH}/places/${id}`,
  GET_TABLES: `${V1_ADMIN_PATH}/tables`,
  ADD_TABLE: `${V1_ADMIN_PATH}/tables/table`,
  UPDATE_TABLE: (id: string) => `${V1_ADMIN_PATH}/tables/table/${id}`,
  UPDATE_TABLE_ITEM: (id: string, sno: number, status: string) => `${V1_ADMIN_PATH}/tables/table/${id}/item/${sno}/update/${status}`,
  DELETE_TABLE: (id: string) => `${V1_ADMIN_PATH}/tables/table/${id}`,
  GET_TABLE: (id: string) => `${V1_ADMIN_PATH}/tables/table/${id}`,
  GET_PROPS: `${V1_ADMIN_PATH}/props`,
  GET_USERS: `${V1_ADMIN_PATH}/users`,
  ADD_USER: `${V1_ADMIN_PATH}/user`,
  UPDATE_USER: (id: string) => `${V1_ADMIN_PATH}/user/${id}`,
  DELETE_USER: (id: string) => `${V1_ADMIN_PATH}/user/${id}`,
  GET_DASHBOARD: (startDate: number, endDate: number) =>
    `${V1_ADMIN_PATH}/analytics/dashboard?startTime=${startDate}&endTime=${endDate}`,
}

export { URLS, EMAIL_API_KEY }
